<template>
  <full-page-loading v-if="!$route.name"/>
  <NotFound v-else-if="$route.name === 'not_found'"/>
  <login v-else-if="$route.name === 'login_micro'"/>
  <template v-else-if="routeRendersRouterView">
    <router-view/>
  </template>
  <template v-else-if="authorised">
    <App :topbarTheme="topbarTheme" :layoutMode="layoutMode" :menuTheme="menuTheme" @menu-theme="onMenuTheme"
         @topbar-theme="onTopbarThemeChange" @layout-mode-change="onLayoutChange">
      <router-view/>
    </App>
  </template>
</template>


<script>
import App from './App.vue';
import NotFound from './pages/NotFound.vue';
import FullPageLoading from './components/FullPageLoading.vue';
import Login from './pages/Auth/LoginNice.vue';
import store from "@/store";
import i18n from "@/locales/i18n";
import {checkLocale} from "@/routes";
import {checkMicrosoftAuthenticationStatus, logout} from "@/authService";
import axiosClient from "@/axios";


export default {
  data() {
    return {
      theme: 'blue',
      layoutMode: 'light',
      topbarTheme: 'lightblue',
      menuTheme: 'light',
    }
  },
  watch: {
    $route(to, from) {
      if (from.params.locale && to.params.locale !== from.params.locale) {
        i18n.setLocale(to.params.locale);
        window.location.reload();
      }
    },
  },
  beforeRouteUpdate: checkLocale,

  methods: {
    async syncLogout() {
      if (this.$store.state.user.isMicrosoftAuthenticated) {
        const isAuthenticated = await checkMicrosoftAuthenticationStatus();

        if (isAuthenticated) {
          await this.extendLaravelSession();
        } else {
          await logout();
        }
      }
    },
    async extendLaravelSession() {
      try {
        const response = await axiosClient.post('/extend-session');

        // Update the auth_token cookie with the new token and expiration time
        const {access_token} = response.data;
        const expirationDate = new Date();
        expirationDate.setSeconds(expirationDate.getSeconds() + 3600);
        document.cookie = `auth_token=${access_token}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax; Secure`;

      } catch (error) {
        console.error("Extend session in Laravel failed:", error);
      }
    },

    onLayoutChange(layout) {
      this.layoutMode = layout;
      this.$appState.layoutMode = layout;
      this.menuTheme = layout;

      const logo = document.getElementById('logo');
      logo.src = 'layout/images/logo-light.svg';

      if (layout === 'dark') {
        this.topbarTheme = 'dark';
      } else {
        this.topbarTheme = 'blue';
      }
    },
    onTopbarThemeChange(theme) {
      this.topbarTheme = theme.name;

      const themeName = theme.name;
      const logo = document.getElementById('logo');

      if (themeName == 'white' || themeName == 'yellow' || themeName == 'amber' || themeName == 'orange' || themeName == 'lime') {
        logo.src = 'layout/images/logo-dark.svg';
      } else {
        logo.src = 'layout/images/logo-light.svg';
      }
    },
    onMenuTheme(menuTheme) {
      this.menuTheme = menuTheme.name;
    }
  },
  computed: {
    store() {
      return store
    },
    authorised() {
      return this.$store.getters.isLogged
    },
    routeRendersRouterView() {
      return [
        'loading',
        'schedule_lessons',
        'students_list',
        'opera_2024_confirm',
        'opera_2024_admin',
        'schedule_student',
        'survey',
        'view_survey_harasment',
        'survey_success'
      ].includes(this.$route.name);
    }
  },
  mounted() {
    if (store.state.user.token) {
      store.dispatch("getUser");
    }
    store.dispatch("getPublicData");
    i18n.setLocale(this.$route.params.locale);
    document.documentElement.style.fontSize = store.state.scale + 'px';
    setInterval(() => {
      this.syncLogout();
    }, 108000); // Check every 30 minute
  },
  components: {
    FullPageLoading,
    "App": App,
    "Login": Login,

    NotFound
  }
}
</script>
